/**
 * 添加员工 
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XTitle } from '@/components/xqxc_ui';
import { Modal, message, Form, Select } from 'antd';
import styles from './AddStaff.module.scss';
import model from '@/reducers/permissions/assignauthority/model';

const { Option } = Select;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
    labelAlign: 'left',
};

class AddStaff extends React.Component {

    formRef = React.createRef();
    state = {
        title: this.props.title,
        confirmLoading: false,
    }

    componentDidMount() {
        const { data } = this.props;
        this.props.getRoleSelect({ roleId: data.roleId });
    }

    // 点击确认
    _handleOk = () => {
        this.formRef.current.validateFields().then((fieldsValue) => {
            const { data } = this.props;
            const { emplIds } = fieldsValue;
            http('/?cmd=com.xqxc.api.pig.mis.biz.account.RoleEmplMisService.addRoleEmpls', { emplIds: emplIds.toString(), roleId: data.roleId }, 'POST').then(() => {
                message.success('添加成功');
                this.props.closeMode(true);
            }).catch((e) => {
                message.error(e.message);
            });
        });
    }

    // 点击取消
    _handleCancel = () => {
        this.props.closeMode();
    }

    // 下拉选择项
    _renderOption = (list) => {
        return list.map((item) => {
            return <Option key={item.id} value={item.id}>{item.emplName}</Option>;
        });
    }

    render() {
        const { confirmLoading, title } = this.state;
        const { roleSelect, data } = this.props;

        return (
            <Modal
                width={900}
                centered
                title={title}
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form
                        {...formItemLayout}
                        layout="vertical"
                        ref={this.formRef}
                        initialValues={{}}
                        scrollToFirstError
                    >
                        <XTitle label={`${'您当前正在进行“' + data.roleName + '”权限分配'}`} style={{ marginBottom: '20px' }} />
                        <Form.Item
                            name="emplIds"
                            rules={[
                                { required: true, message: '请选择员工' }
                            ]}>

                            <Select
                                mode="multiple"
                                showSearch
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                optionFilterProp="children"
                            >
                                {this._renderOption(roleSelect)}
                            </Select>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }
}

AddStaff.propTypes = {
    data: PropTypes.object, // 弹框入参
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string, // 弹框标题
    getRoleSelect: PropTypes.func, // 获取角色选择
    roleSelect: PropTypes.array, // 角色选择
};

const mapStateToProps = (state) => ({
    roleSelect: state.assignauthority.getRoleSelect,
});

export default connect(mapStateToProps, { ...model.actions })(AddStaff);